<template>
  <div class="card">
    <div class="card-header">
      <h1>Modifier le profil</h1>
    </div>
    <div class="card-body">
      <form ref="profile_form" @submit.prevent="handleProfileUpdate">
        <div class="form-group">
          <label class="form-control-label"> Picture </label>
          <div v-if="image" class="profile-image card-img pb-4">
            <img :src="`${image}`" class="profile-image argon-image" />
          </div>
          <div v-else class="profile-image">
            <img
              :src="
                user.profile_image ? user.profile_image : '/img/placeholder.jpg'
              "
              class="argon-image"
            />
          </div>
          <div class="image-upload">
            <base-button
              v-if="image"
              type="button"
              class="btn btn-sm btn-danger"
              @click="removeImage"
            >
              <span>
                <i class="fa fa-times" />
                Supprimer l'image
              </span>
            </base-button>
            <base-button type="button" class="btn btn-sm btn-primary p-0">
              <label
                v-if="!image"
                for="imageInput"
                class="mb-0 p-1"
                role="button"
              >
                Choisir une image
              </label>
              <label v-else for="imageInput" class="mb-0 p-1" role="button"
                >Changer</label
              >
              <input
                id="imageInput"
                ref="imageInput"
                accept="image/*"
                type="file"
                style="display: none"
                @input="onFileChange"
              />
            </base-button>
          </div>
        </div>
        <validation-error :errors="apiValidationErrors.attachment" />
        <base-input
          label="Nom"
          prepend-icon="fas fa-user"
          placeholder="Votre nom"
          v-model="user.name"
          :disabled="true"
        />
        <validation-error :errors="apiValidationErrors.name" />
        <base-input
          label="Courriel"
          prepend-icon="fas fa-envelope"
          placeholder="Courriel"
          v-model="user.email"
          :disabled="true"
        />
        <validation-error :errors="apiValidationErrors.email" />
        <div class="my-4">
          <base-button
            type="button"
            class="btn btn-sm btn-primary"
            native-type="submit"
          >
            Enregistrer
          </base-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  name: "UserEditCard",

  components: {
    BaseInput,
    BaseButton,
    ValidationError,
  },

  mixins: [formMixin],

  props: {
    user: Object,
  },

  data() {
    return {
      image: null,
      file: null,
    };
  },

  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.image = null;
      this.file = null;
      this.$refs.imageInput.value = null;
    },

    async handleProfileUpdate() {
      try {
        if (this.file) {
          await this.$store.dispatch("users/upload", {
            user: this.user,
            image: this.file,
          });
          this.user.profile_image = await this.$store.getters["users/url"];
        }

        await this.$store.dispatch("profile/update", this.user);

        this.removeImage();
        this.resetApiValidation();
        this.$notify({
          type: "success",
          message: "Profile updated successfully.",
        });

        await this.$store.getters["profile/me"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
